import { Auth0User } from '@/common/utils';
import { CreateUserRequest } from '@packages/api/packaging/types/generated/createUser.request';

export type PackaRole = Extract<CreateUserRequest['roles'][number], `packa_${string}`>;

export const packaRoles = [
  'packa_packaging_read',
  'packa_packaging_write',
  'packa_pricing_read',
  'packa_pricing_write',
  'packa_sustainability_read',
  'packa_sustainability_write',
  'packa_documents_read',
  'packa_documents_write',
  'packa_settings_read',
  'packa_settings_write',
  'packa_reporting_read',
  'packa_reporting_write',
] as const satisfies readonly PackaRole[];

export const packaRoleLabels: Record<PackaRole, string> = {
  packa_packaging_read: 'Packaging Read',
  packa_packaging_write: 'Packaging Write',
  packa_pricing_read: 'Pricing Read',
  packa_pricing_write: 'Pricing Write',
  packa_sustainability_read: 'Sustainability Read',
  packa_sustainability_write: 'Sustainability Write',
  packa_documents_read: 'Documents Read',
  packa_documents_write: 'Documents Write',
  packa_settings_read: 'Settings Read',
  packa_settings_write: 'Settings Write',
  packa_reporting_read: 'Reporting Read',
  packa_reporting_write: 'Reporting Write',
};

export const isPackaRole = (role: unknown): role is PackaRole =>
  typeof role === 'string' && role.startsWith('packa_');

export const isAdminUser = (user: Auth0User): boolean => {
  return user.pm.roles.includes('admin') || false;
};

export const packaPermissions = [
  'read:packaging',
  'write:packaging',
  'read:sustainability',
  'write:sustainability',
  'read:imports',
  'write:imports',
  'read:pricing',
  'write:pricing',
  'read:documents',
  'write:documents',
  'read:settings',
  'write:settings',
  'read:reporting',
  'write:reporting',
] as const;

export type PackaPermission = (typeof packaPermissions)[number];
